<template>
    <div>
        <div class="title" :style="getTitleStyle()">
            {{ myObj.photo_classify_line_tiny_params.title }}
        </div>
        <div class="list-box" :style="getListBoxStyle()">
            <div v-for="(item, index) in 10" class="item" :key="index">
                <div :style="getIconStyle()" class="icon"></div>
                <span>名称</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PhotoClassifyLineTinyView",
    props: ['obj'],
    data() {
        return {
            myObj: this.obj,

        }
    },
    methods: {
        getTitleStyle() {
            return 'margin-left: ' + this.obj.photo_classify_line_tiny_params.margin + 'px;';
        },
        getListBoxStyle() {
            return 'padding-left: ' + this.obj.photo_classify_line_tiny_params.margin + 'px;' +
                'padding-bottom: ' + this.obj.photo_classify_line_tiny_params.margin + 'px;'+
                'gap:' + this.obj.photo_classify_line_tiny_params.between_space + 'px;';
        },
        getIconStyle() {
            return 'width:' + this.obj.photo_classify_line_tiny_params.icon_width + 'px;' +
                'height:' + this.obj.photo_classify_line_tiny_params.icon_height + 'px;' +
                'line-height:' + this.obj.photo_classify_line_tiny_params.icon_height + 'px;' +
                'border-radius:' + this.obj.photo_classify_line_tiny_params.corner_radius + 'px;';
        }
    }
}
</script>

<style scoped lang="less">
.title {
    color: black;
    font-size: medium;
    line-height: 40px;
}

.list-box {
    overflow-x: hidden;
    overflow-y: hidden;
    white-space: nowrap;
    display: flex;

    .item {
        display: inline-block;
        text-align: center;
        font-size: small;

        .icon {
            background-color: #d8d7d7;
            margin-bottom: 5px;
        }
    }
}
</style>